import { useEffect, useState } from "react";
import { productApi } from "../api/productApi";
import { cartApi } from "../api/cartApi";
import ProductCard from "../components/ProductCard";
import Message from "../components/Message";

export default function Home({ onCartUpdate }) {
  const [products, setProducts] = useState([]);
  const [notice, setNotice] = useState(null);

  useEffect(() => {
    productApi.getFeatured().then((data) => {
      setProducts(data.products || data.items || []);
    }).catch((error) => setNotice({ type: "error", text: error.message }));
  }, []);

  async function handleAddToCart(productId) {
    try {
      await cartApi.addToCart(productId, 1);
      setNotice({ type: "success", text: "Product added to cart." });
      // Update cart count in navbar
      if (onCartUpdate) {
        const cart = await cartApi.getCart();
        const count = cart.items 
          ? cart.items.reduce((total, item) => total + item.quantity, 0)
          : 0;
        onCartUpdate(count);
      }
    } catch (error) {
      setNotice({ type: "error", text: error.message });
    }
  }

  return (
    <>
      <div className="hero-section">
        <div className="hero-content">
          <h1>Welcome to IoTBay</h1>
          <p>Discover amazing products at unbeatable prices</p>
          <a href="/shop" className="btn btn-primary btn-lg">Start Shopping</a>
        </div>
      </div>

      <section className="featured-products">
        <div className="container">
          <h2 className="section-title">Featured Products</h2>
          <Message notice={notice} />
          <div className="products-grid">
            {products.map((product) => (
              <ProductCard
                key={product.id}
                product={product}
                onAddToCart={handleAddToCart}
                compact
              />
            ))}
          </div>
        </div>
      </section>

      <section className="features">
        <div className="container">
          <div className="features-grid">
            <div className="feature-card"><div className="feature-icon">🚚</div><h3>Fast Delivery</h3><p>Quick and reliable shipping to your doorstep</p></div>
            <div className="feature-card"><div className="feature-icon">🔒</div><h3>Secure Payment</h3><p>Safe and encrypted payment processing</p></div>
            <div className="feature-card"><div className="feature-icon">↩️</div><h3>Easy Returns</h3><p>Hassle-free returns within 30 days</p></div>
            <div className="feature-card"><div className="feature-icon">⭐</div><h3>Quality Products</h3><p>All products guaranteed authentic and tested</p></div>
          </div>
        </div>
      </section>
    </>
  );
}
